import { Link } from "react-router-dom";
import { CircleSlash } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ResultShell } from "@/pages/PaymentSuccess";

export default function PaymentCancel() {
  return (
    <ResultShell testid="payment-cancel" icon={<CircleSlash className="h-14 w-14 text-[#F4A261]" />}
      title="Pago cancelado" text="No se ha realizado ningún cargo. Si tienes dudas sobre qué paquete elegir, pide una cotización y te asesoramos.">
      <div className="flex flex-col justify-center gap-3 sm:flex-row">
        <Button asChild className="rounded-full bg-[#E05A47] px-6 hover:bg-[#c94a38]" data-testid="cancel-back-packages"><Link to="/#paquetes">Ver paquetes</Link></Button>
        <Button asChild variant="outline" className="rounded-full px-6" data-testid="cancel-quote"><Link to="/#contacto">Pedir cotización</Link></Button>
      </div>
    </ResultShell>
  );
}
